<div class="layout-wrapper">
  <!-- Top Navbar -->
  <header class="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-outline-variant/50 flex items-center h-16 px-margin-desktop w-full">
    <div class="flex-none flex items-center gap-6">
      <i class="fas fa-bars text-on-surface-variant cursor-pointer hover:text-primary transition-colors text-xl" (click)="toggleSidebar()"></i>
      <img [src]="temaService.escuro() ? '/assets/img/logo_Previmil_branca.png' : '/assets/img/logo_Previmil.png'" alt="Previmil" class="h-[30px] w-auto">
    </div>

    <!-- Zona central: badge do módulo atual. Alimentada via CabecalhoContextoService
         (tela-basica escreve nela) — fica entre a logo e o bloco do usuário de verdade,
         como filho flex do header, em vez do position:fixed centralizado no viewport
         que causava a sobreposição encontrada na auditoria visual. -->
    <div class="cabecalho-central flex-1 min-w-0 flex items-center justify-center gap-4 px-4 overflow-hidden">
      <div class="modulo-badge flex-none flex items-center gap-3" *ngIf="cabecalhoContexto.moduloAtual() as modulo">
        <i style="font-size:23px;" [class]="modulo.icone"></i>
        <div class="modulo-badge__texto min-w-0">
          <p class="modulo-badge__nome">{{ modulo.nome }}</p>
          <p class="modulo-badge__subtitulo" *ngIf="modulo.subtitulo">{{ modulo.subtitulo }}</p>
        </div>
      </div>
    </div>

    <div class="flex-none flex items-center gap-8">
      <div class="hidden md:flex items-center gap-4 text-right" *ngIf="usuarioConectadoInfo$ | async as usuario">
        <div class="flex flex-col">
          <p class="font-bold text-primary text-body-base leading-tight">{{ usuario.nomeCompleto }}</p>
          <p class="text-on-surface-variant/70 text-[12px] uppercase tracking-wide font-bold">{{ usuario.lotacao }}</p>
        </div>
        <div class="w-10 h-10 rounded-full bg-surface-container-high flex items-center justify-center overflow-hidden border border-outline-variant/30">
          <i class="fas fa-user-circle text-primary text-2xl"></i>
        </div>
      </div>
      <button type="button"
        class="theme-toggle flex items-center justify-center w-9 h-9 rounded-full border border-outline-variant/30 text-on-surface-variant hover:text-primary transition-colors"
        [attr.aria-label]="temaService.escuro() ? 'Mudar para tema claro' : 'Mudar para tema escuro'"
        [attr.aria-pressed]="temaService.escuro()"
        title="Alternar tema claro/escuro"
        (click)="temaService.alternar()">
        <i class="fas" [ngClass]="temaService.escuro() ? 'fa-sun' : 'fa-moon'"></i>
      </button>
      <!-- #4: SAIR com cor de erro por padrão; VOLTAR em tom neutro com contexto de destino (#14) -->
      <div class="flex border-l border-outline-variant/30 pl-8 gap-6">
        <button class="flex items-center gap-2 text-error/80 hover:text-error transition-colors font-bold text-label-caps" (click)="sairSistema()">
          <i class="fas fa-sign-out-alt text-sm"></i>
          <span class="hidden sm:inline">SAIR</span>
        </button>
        <button class="flex items-center gap-2 text-on-surface-variant hover:text-primary transition-colors font-bold text-label-caps" (click)="executarVoltar()">
          <i class="fas fa-arrow-left text-sm"></i>
          <span class="text-[11px] tracking-widest uppercase hidden sm:inline">
            {{ getNomeModuloAtual() ? '← ' + getNomeModuloAtual() : 'VOLTAR' }}
          </span>
        </button>
      </div>
    </div>
  </header>

  <div class="flex h-screen pt-16">
    <!-- Sidebar -->
    <aside class="sidebar flex flex-col border-r border-outline-variant/50 bg-surface-container-lowest h-full no-scrollbar"
           [class.collapsed]="isCollapsed">

      <!-- Badge de ambiente -->
      <div *ngIf="getAmbienteType() !== 'prod'"
           class="border-y py-2 text-center mb-2"
           [ngClass]="{
             'bg-orange-100 border-orange-300 text-orange-800': getAmbienteType() === 'homolog',
             'bg-secondary-container/20 border-secondary-container/30 text-on-secondary-container': getAmbienteType() === 'dev'
           }">
        <span class="text-[9px] font-black tracking-widest uppercase">
          {{ isCollapsed ? getAmbienteAbrev() : getAmbiente() }}
        </span>
      </div>

      <!-- Itens de navegação (#6: title tooltip, #8: contraste ativo) -->
      <nav class="flex flex-col w-full no-scrollbar gap-1 px-2 overflow-y-auto flex-1">
        <ng-container *ngFor="let item of rotasNavegacao">
          <a class="sidebar-item relative flex items-center py-3 rounded-lg overflow-hidden"
             [title]="item.nome"
             [class.flex-col]="isCollapsed"
             [class.justify-center]="isCollapsed"
             [class.flex-row]="!isCollapsed"
             [class.gap-3]="!isCollapsed"
             [class.px-4]="!isCollapsed"
             [ngClass]="{
               'text-primary font-semibold': isActive(item.caminho),
               'text-on-surface-variant': !isActive(item.caminho)
             }"
             [routerLink]="item.caminho">
            <!-- faixa lateral da cor base — indicador de item ativo -->
            <span *ngIf="isActive(item.caminho)"
                  class="absolute left-0 top-1 bottom-1 w-1 rounded-r-full"
                  [ngClass]="{
                    'bg-orange-400': getAmbienteType() === 'homolog',
                    'bg-primary':    getAmbienteType() === 'prod',
                    'bg-secondary-container': getAmbienteType() === 'dev'
                  }"></span>
            <i class="text-[22px] flex-shrink-0 w-[28px] text-center" [ngClass]="item.icone"></i>
            <span *ngIf="!isCollapsed" class="text-body-sm font-semibold truncate sidebar-label">{{ item.nome }}</span>
          </a>
        </ng-container>
      </nav>
    </aside>

    <!-- Main Content -->
    <main class="main-content flex-1 p-6 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
